"use strict";
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.logApi = exports.SDK_TAG = exports.DEFAULT_LEVEL = exports.LOG_LEVELS = void 0;
exports.LOG_LEVELS = {
    OFF: 0,
    ERROR: 1,
    WARN: 2,
    DEBUG: 3,
};
exports.DEFAULT_LEVEL = "ERROR";
exports.SDK_TAG = "ADP";
const COMMON_TAG_CSS = "color: white; font-weight: bold; border-radius: 4px; padding: 2px 4px";
class Logger {
    constructor() {
        this.level = exports.LOG_LEVELS[exports.DEFAULT_LEVEL];
    }
    setLevel(level) {
        if (exports.LOG_LEVELS[level] == null) {
            throw new Error(`Invalid log level provided to logger. Options include: ${Object.keys(exports.LOG_LEVELS).join(", ")}`);
        }
        this.level = exports.LOG_LEVELS[level];
        if (this.level === exports.LOG_LEVELS.DEBUG) {
            this.debug("Setting logging level to DEBUG. This is NOT recommended for production use.");
        }
    }
    log(levelOfMessage, tags, extraPrepend, ...message) {
        if (this.level < levelOfMessage) {
            return;
        }
        const prepend = `${tags.map((t) => `%c${t.text}`).join("")}${extraPrepend}`;
        const styles = tags.map((tag, i) => {
            return `${COMMON_TAG_CSS}; background-color: ${tag.color};${i ? "margin-left: 0.5em;" : ""}`;
        });
        switch (levelOfMessage) {
            case exports.LOG_LEVELS.DEBUG:
                console.info(prepend, ...styles, ...message);
                break;
            case exports.LOG_LEVELS.WARN:
                console.warn(prepend, ...styles, ...message);
                break;
            case exports.LOG_LEVELS.ERROR:
                console.error(prepend, ...styles, ...message);
                break;
            default:
        }
    }
    logApi(method, args) {
        var _a;
        (_a = this.listener) === null || _a === void 0 ? void 0 : _a.call(this, method, ...args);
        this.log(exports.LOG_LEVELS.DEBUG, [
            { text: exports.SDK_TAG, color: "Green" },
            { text: "API", color: "SandyBrown" },
            { text: method, color: "Orchid" },
        ], `%c(${args.map(() => "%o").join(", ")})`, undefined, ...args);
    }
    debug(...optionalParams) {
        var _a;
        (_a = this.listener) === null || _a === void 0 ? void 0 : _a.call(this, ...optionalParams);
        this.log(exports.LOG_LEVELS.DEBUG, [{ text: exports.SDK_TAG, color: "Green" }], "", ...optionalParams);
    }
    warn(...optionalParams) {
        var _a;
        (_a = this.listener) === null || _a === void 0 ? void 0 : _a.call(this, ...optionalParams);
        this.log(exports.LOG_LEVELS.WARN, [{ text: exports.SDK_TAG, color: "Orange" }], "", ...optionalParams);
    }
    error(...optionalParams) {
        var _a;
        (_a = this.listener) === null || _a === void 0 ? void 0 : _a.call(this, ...optionalParams);
        this.log(exports.LOG_LEVELS.ERROR, [{ text: exports.SDK_TAG, color: "Red" }], "", ...optionalParams);
    }
}
const log = new Logger();
exports.default = log;
function logApi() {
    return (_target, propertyKey, descriptor) => {
        const originalMethod = descriptor.value;
        descriptor.value = function desc(...args) {
            log.logApi(propertyKey, args);
            return originalMethod.apply(this, args);
        };
        return descriptor;
    };
}
exports.logApi = logApi;
